module.exports = __webpack_public_path__ + "img/img3.40f83bd5.jpg";